import moment from 'moment'

export { savedWhen, normalizeUTCTimeFromLocalTz }

function savedWhen(createdAt) {
  var date = new Date(createdAt)
  var m = moment(date)
  return m.fromNow()
}

function normalizeUTCTimeFromLocalTz() {
  // moment() will use the browser's local timezone
  return moment().format('YYYY-MM-DD') + 'T00:00:00Z'
}
